var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.052 78.021a1.5 1.5 0 0 1-1.46-1.84L46.268 60.4h-5.686a1.5 1.5 0 0 1-1.248-2.334l16.543-24.739a1.5 1.5 0 0 1 2.707 1.173l-3.9 16.554h5.836a1.5 1.5 0 0 1 1.237 2.35L45.289 77.371a1.5 1.5 0 0 1-1.237.65ZM43.389 57.4h4.768a1.5 1.5 0 0 1 1.461 1.841l-2.3 9.891 10.36-15.07H52.8a1.5 1.5 0 0 1-1.46-1.844l2.432-10.335Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.589 91.007H34.827a7.812 7.812 0 0 1-7.8-7.8v-55.42a7.813 7.813 0 0 1 7.8-7.8h31.762a7.813 7.813 0 0 1 7.8 7.8V83.2a7.812 7.812 0 0 1-7.8 7.807ZM34.827 22.983a4.809 4.809 0 0 0-4.8 4.8V83.2a4.809 4.809 0 0 0 4.8 4.8h31.762a4.809 4.809 0 0 0 4.8-4.8V27.787a4.809 4.809 0 0 0-4.8-4.8Zm23.998-5.256H41.973a1.5 1.5 0 0 1-1.5-1.5v-4a4.6 4.6 0 0 1 4.589-4.589h10.673a4.6 4.6 0 0 1 4.59 4.589v4a1.5 1.5 0 0 1-1.5 1.5Zm-15.352-3h13.852v-2.5a1.591 1.591 0 0 0-1.59-1.589H45.062a1.591 1.591 0 0 0-1.589 1.589Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.b09f568038434b7777f36cd9161bcdcc.svg";
export { ForwardRef as ReactComponent };